<!--This component (step 2) to choose reservation date and time-->
<template>
  <v-card-text>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <div class="mb-5 headline font-weight-bold headline1--text">
          {{ $t("generic.lang_date_time_title") }}
        </div>
      </v-col>

      <!--Start DatePicker-->
      <v-col cols="12" xs="12" sm="12" md="5" lg="5">
        <div class="pb-3 font-weight-regular">
          {{ $t("generic.lang_select_date") }}
        </div>

        <v-card elevation="0" tile class="pt-2" :loading="loadingDates">
          <v-date-picker
            :disabled="loadingDates"
            v-model="date"
            color="primary"
            no-title
            full-width
            :first-day-of-week="1"
            @update:picker-date="getAvailableDates"
            :allowed-dates="allowedDates"
            :min="new Date().toISOString()"
          />
        </v-card>
      </v-col>
      <!--End DatePicker-->

      <!--Start Times-->
      <v-col cols="12" xs="12" sm="12" md="7" lg="7">
        <div class="pb-3 font-weight-regular">
          {{ $t("generic.lang_select_time") }}
        </div>

        <div v-if="loading" class="text-center">
          <v-progress-circular indeterminate color="primary" size="128" />
        </div>

        <v-card v-else-if="this.times.length != 0" elevation="0" tile>
          <v-chip-group v-model="time" active-class="primary" column>
            <div align="center" justify="start">
              <v-chip
                v-for="(time, i) in times"
                :key="i"
                :value="time"
                :disabled="timeValidate(time)"
                large
                label
                tile
                color="rgb(248, 247, 247)"
              >
                {{ time }}
              </v-chip>
            </div>
          </v-chip-group>
        </v-card>

        <v-card v-else elevation="0" tile class="text-center pt-15">
          <div>
            <p v-show="!loading">
              {{ $t("generic.lang_no_time_available") }}
            </p>
          </div>
        </v-card>
      </v-col>
      <!--End Times-->

      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        v-if="this.$vuetify.breakpoint.mdAndUp"
      >
        <div class="my-16"></div>
      </v-col>

      <!--***-->
    </v-row>
  </v-card-text>
</template>

<script>
import moment from "moment";
/*import plugins*/
import { createNamespacedHelpers } from "vuex";
import ENDPOINTS from "../../plugins/axios/endpoints";

export default {
  name: "Step2Component",
  data() {
    return {
      resTime: null,
      dates: [],
      loadingDates: false,
      calendar: {
        start: null,
        end: null
      }
    };
  },
  computed: {
    ...createNamespacedHelpers("loader").mapGetters(["loading"]),
    ...createNamespacedHelpers("dateTime").mapGetters([
      "openDaysIndex",
      "times"
    ]),
    ...createNamespacedHelpers("config").mapGetters(["serverTime"]),

    language() {
      return this.$i18n.locale;
    },

    date: {
      get() {
        return this.$store.state.dateTime.date;
      },
      set(value) {
        this.$store.commit("dateTime/addDate", value);
        this.$store.commit("config/isNextBtn", false);
        this.getAvailableTimes(value)
      }
    },

    time: {
      get() {
        return this.$store.state.dateTime.time;
      },
      set(value) {
        this.$store.commit("dateTime/addTime", value);
        window.store.commit("config/isNextBtn", !!value);
      }
    }
  },

  methods: {
    allowedDates(val) {
      if (this.dates.length > 0) {
        return this.dates.includes(moment(val, "YYYY-MM-DD").format("DD.MM.YYYY") );
      }
      return false;
    },

    //allowedDates: (val) => ![1, 2].includes(new Date(val).getDay()),
    //allowedDates: (val) => new Date(val).getDay() === 3 ||

    getAvailableTimes(date, reset=true) {
      if (reset) {
        this.$store.commit("dateTime/addTime", "");
      }

      this.$store.dispatch("dateTime/fetchOpenTimes", {
        type_uuid:
          this.$store.getters["reservationTypes/reservationTypeUuid"] || null,
        maxperson: this.$store.getters["reservationTypes/numberPersons"] || null,
        date: date
      });
    },
    getAvailableDates(month) {
      this.loadingDates = true;
      if (month) {
        this.setCalendarRange(month);
      } else {
        this.setCalendarRange(
          moment(this.serverTime, "DD:MM:YYYY hh:mm").format("YYYY-MM")
        );
      }

      this.dates = [];

      this.axios
        .get(ENDPOINTS.ONLINE_SERVICES.AVAILABLE_DATES, {
          params: {
            type_uuid:
              this.$store.getters["reservationTypes/reservationTypeUuid"] || null,
            maxperson: this.$store.getters["reservationTypes/numberPersons"] || null,
            start_date: this.calendar.start,
            end_date: this.calendar.end
          }
        })
        .then(res => {
          if(res.status === 200){
            this.dates = res.data.filter(item=> !item.isExpired).map(item=> item.date);
          }else {
            this.$swal({
              title: this.$t("generic.lang_error"),
              icon: "error",
              text: res.data.message,
              //text: err.response.data.message,
            });
          }
        }).catch(err => {
          this.$swal({
            title: this.$t("generic.lang_error"),
            icon: "error",
            text: err.message,
            //text: err.response.data.message,
          });
        })
        .finally(() => {
          this.loadingDates = false;
        });
    },
    setCalendarRange(month) {
      this.calendar.start = moment
        .utc(month, "YYYY-MM")
        .startOf("month")
        .format("YYYY-MM-DD");
      this.calendar.end = moment
        .utc(month, "YYYY-MM")
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    timeValidate(val) {
      if (
        moment(this.serverTime, "hh:mm").isSameOrAfter(moment(val, "hh:mm")) &&
        moment(this.date, "YYYY-MM-DD").isSame(moment().format("YYYY-MM-DD"))
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (!this.date) {
      this.date = moment().format("YYYY-MM-DD");
    }else {
      this.getAvailableTimes(this.date, false);
    }
  },
};
</script>

<style>
.v-date-picker-table {
  background-color: rgb(248, 247, 247);
}

.v-date-picker-header {
  background-color: rgb(248, 247, 247);
}

.v-btn {
  /*background-color: rgb(250, 179, 145);*/
}
</style>
